<template>
  <div class="filters-bar col-md-12 px-0">
    <div class="filters-bar__fields">
      <template v-for="(filter, index) in filters">
        <v-autocomplete
          class="filters-bar__field"
          v-if="filter.type === 'select'"
          outlined
          dense
          hide-details
          :key="index"
          :label="filter.label"
          :items="filter.items"
          item-text="name"
          item-value="id"
          @change="getModelSelect($event, filter)"
          clearable
          no-data-text="Nenhum Resultado"
          v-model="query[filter.name]"
        ></v-autocomplete>

        <v-text-field
          class="filters-bar__field"
          v-if="filter.type === 'text'"
          outlined
          dense
          hide-details
          :key="index"
          :label="filter.label"
          @input="getModelText($event, filter)"
          v-model="query[filter.name]"
        ></v-text-field>

        <div
          v-if="filter.type === 'date'"
          :key="index"
          class="filters-bar__field"
        >
          <date-picker 
            :label="filter.label"
            :readOnly="false"
            dense
            hide="auto"
            :binding.sync="query[filter.name]"
            @change="getModelDate(filter)"
          />
        </div>
      </template>
    </div>

    <div class="filters-bar__actions">
      <v-btn 
        class="btn success" 
        height="40"
        @click="$emit('search')"
      >
        <i 
          class="mdi mdi-magnify pr-1" 
          style="font-size:1.2rem">
        </i>
        Pesquisar
      </v-btn>
      
      <button
        v-if="showCleareble"
        type="button"
        class="filters-bar__clear"
        aria-label="Remover pesquisa"
        v-tooltip.top="{content:'Remover pesquisa'}"
        @click="removeFilter"
      >
        <i class="mdi mdi-close"></i>
      </button>
    </div>
  </div>
</template>

<script>
import DatePicker from "@/components/layout/DatePicker";

export default {
  name:"TheFilters",
  components:{
    DatePicker
  },
  props:{
    filters:Array,
    showCleareble:Boolean
  },
  data() {
    return {
      date_param:null,
      query:{}
    }
  },
  methods: {
    //Metodos de getModel são para pegar os valores e emitir os mesmos para o component pai
    getModelSelect(data, filter) {
      this.$emit("get-model", {title:filter.name, value:data});
    },
    getModelText(data, filter) {
      this.$emit("get-model", {title:filter.name, value:data});
    },
    getModelDate(filter) {
      this.$emit("get-model", {title:filter.name, value:this.query[filter.name]});
    },
    //Esse metodo reseta as querys e a pesquisa
    removeFilter() {
      this.$emit('on-cleareble');
      this.query = {};
      this.date_param = null;
    }
  }
}
</script>

<style>
  .filters-bar {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    padding: 4px 0 18px !important;
    margin-bottom: 8px;
    border-bottom: 1px solid var(--line);
  }
  .filters-bar__fields {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    flex: 1;
  }
  .filters-bar .filters-bar__field {
    flex: 1 1 170px;
    max-width: 260px;
  }
  @media (max-width: 600px) {
    .filters-bar {
      flex-direction: column;
      align-items: stretch;
    }
    .filters-bar .filters-bar__field {
      max-width: none;
      flex-basis: 100%;
    }
    .filters-bar__actions {
      justify-content: flex-end;
    }
  }
  .filters-bar__actions {
    display: flex;
    align-items: center;
    gap: 6px;
    flex-shrink: 0;
  }
  .filters-bar__clear {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.3rem;
    color: var(--muted);
    transition: background-color .15s ease, color .15s ease;
  }
  .filters-bar__clear:hover {
    background: #f1f2f6;
    color: #d33;
  }
</style>
